export const ParticipantChannelType = {
  Web: 0,
  SMS: 1,
  WhatsApp: 2,
  Facebook: 3,
  All: 4,
};
export const MessageType = {
  Customer: 0,
  Agent: 1,
  Supervisor: 2,
  Admin: 3,
  Bot: 4,
};
export const CLOSED_BY = {
  0: 'System',
  1: 'Customer',
  2: 'Agent',
};

export const AGENT_STATUS = {
  0: 'Offline',
  1: 'Break',
  2: 'Available',
};

export const ConversationStatus = {
  Open: 0,
  Closed: 1,
};

export const RATING_CATEGORY = {
  0: 'Satisfaction',
  1: 'Knowledge',
  2: 'Responsive',
  3: 'Friendly',
  4: 'Additional',
};

export const NOTIFICATION_SETTINGS = {
  Position: 'top-right',
  AutoClose: 5000,
  HideProgressBar: false,
  CloseOnClick: true,
  PauseOnHover: true,
  Draggable: true,
  NewestOnTop: true,
  Progress: undefined,
};
export const ChatStatusMapping = {
  Offline: 0,
  OnBreak: 1,
  Available: 2,
};

export const CUSTOMER_ICON = `/images/accountuser.svg`;
export const NO_CHAT_IMAGE = `/images/no-chat.jpg`;
export const WHATSAPP_IMAGE = `/images/whatsapp.png`;
export const WEB_IMAGE = `/images/web.png`;
export const SMS_IMAGE = `/images/sms.png`;
export const MESSENGER_IMAGE = `/images/facebook-messenger.png`;
export const PARTICIPANT_TYPE = {
  0: 'Agent',
  1: 'Web',
  2: 'SMS',
  3: 'WhatsApp',
};
export const PARTICIPANT_ICON = {
  0: WEB_IMAGE,
  1: SMS_IMAGE,
  2: WHATSAPP_IMAGE,
  3: MESSENGER_IMAGE,
  4: '',
};
export const CHANNEL_TYPES = {
  0: 'Web',
  1: 'SMS',
  2: 'WhatsApp',
  3: 'Facebook',
  4: '',
};
export const ChannelType = {
  Web: 0,
  SMS: 1,
  WhatsApp: 2,
  Facebook: 3,
  // All: 4,
};

export const ConversationType = {
  General: 0,
  Customer: 1,
  Agent: 2,
};

export const DragFields = [
  {
    id: 1,
    name: 'INPUT',
    value: '',
    canDrag: true,
  },
  {
    id: 2,
    name: 'ADJECTIVE',
    value: 'ADJ',
    canDrag: true,
  },

  {
    id: 3,
    name: 'PREPOSITION',
    value: 'ADP',
    canDrag: true,
  },
  {
    id: 4,
    name: 'ADVERB',
    value: 'ADV',
    canDrag: true,
  },
  {
    id: 5,
    name: 'CONJUNCTION',
    value: 'CONJ',
    canDrag: true,
  },
  {
    id: 6,
    name: 'INTERJECTION',
    value: 'INTJ',
    canDrag: true,
  },
  {
    id: 7,
    name: 'NOUN',
    value: 'NOUN',
    canDrag: true,
  },
  {
    id: 8,
    name: 'VERB',
    value: 'VERB',
    canDrag: true,
  },
  {
    id: 9,
    name: 'PRONOUN',
    value: 'PRON',
    canDrag: true,
  },
];

export const sentimentType = {
  Positive: 'clr-green',
  Neutral: 'clr-orange',
  Negative: 'clr-pink',
};

export const sentimentsList = {
  Positive: 1,
  Neutral: '0',
  Negative: -1,
  UnClassified: 2,
};

export const sentimentsLabel = {
  1: 'Positive',
  0: 'Neutral',
  '-1': 'Negative',
  2: 'UnClassified',
};

export const DeliveryReceiptsEnum = {
  0: 'delivered',
  1: 'failed',
  2: 'read',
  3: 'sent',
  4: 'undelivered',
};

export const time24HourList = [
  { value: 1, label: '01:00' },
  { value: 2, label: '02:00' },
  { value: 3, label: '03:00' },
  { value: 4, label: '04:00' },
  { value: 5, label: '05:00' },
  { value: 6, label: '06:00' },
  { value: 7, label: '07:00' },
  { value: 8, label: '08:00' },
  { value: 9, label: '09:00' },
  { value: 10, label: '10:00' },
  { value: 11, label: '11:00' },
  { value: 12, label: '12:00' },
  { value: 13, label: '13:00' },
  { value: 14, label: '14:00' },
  { value: 15, label: '15:00' },
  { value: 16, label: '16:00' },
  { value: 17, label: '17:00' },
  { value: 18, label: '18:00' },
  { value: 19, label: '19:00' },
  { value: 20, label: '20:00' },
  { value: 21, label: '21:00' },
  { value: 22, label: '22:00' },
  { value: 23, label: '23:00' },
  { value: 24, label: '24:00' },
];
